import React from 'react';

function HeatmapSettingsDialogHeader() {
  return (
    <div className="heatmap-settings-dialog__header">
      <h4>Bioactivity Visualization Settings</h4>
    </div>
  );
}
export default HeatmapSettingsDialogHeader;
